<template>
  <el-form-item :class="{ 'is-required': required }" :label="label" :prop="prop" :show-message="showMessage">
    <ny-upload v-bind="$attrs" v-model="fileList" v-on="$listeners"></ny-upload>
  </el-form-item>
</template>

<script>
import NyUpload from '../upload'

export default {
  name: 'NyFormItemUpload',
  components: {
    NyUpload
  },
  props: {
    value: {
      required: true
    },
    required: Boolean,
    label: String,
    prop: String,
    showMessage: Boolean
  },
  data () {
    return {
      fileList: this.value
    }
  },
  watch: {
    value (newVal) {
      this.fileList = newVal
    }
  }
}
</script>
